/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ChecklistMultiChoiceOption } from './checklist-multi-choice-option';

export class ChecklistMultiChoiceConfig {
  isMultiSelect: boolean;
  options: ChecklistMultiChoiceOption[];
}
